import { css } from '@emotion/core';
import { tokens, variables } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var global = variables.global;
var colors = tokens.colors;
export var drawer = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:center;padding-left:50px;padding-right:50px;padding-top:16px;background:linear-gradient( 0deg,rgba(0,0,0,0.8) 0%,rgba(0,0,0,0.4) 80%,rgba(0,0,0,0) 100% );opacity:0;z-index:", global.layerModal, ";");
export var interactive = {
  name: "vro3gk",
  styles: "background:inherit;"
};
export var info = /*#__PURE__*/css(typography.bodySmall, " color:", colors.neutral.subdued.default, ";display:flex;justify-content:space-between;width:100%;");
export var thumbnails = {
  name: "ibnnmb",
  styles: "margin-left:8px;margin-right:8px;"
};
export var title = {
  name: "1d0tddh",
  styles: "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"
};
export var show = {
  name: "qxhst0",
  styles: "visibility:visible;opacity:1;transition:opacity 0.5s linear;"
};
export var hide = {
  name: "nhfyzs",
  styles: "visibility:hidden;opacity:0;transition:visibility 0s 0.5s,opacity 0.5s linear;"
};